<template>
  <el-row :gutter="20">
    <el-col :md="extraFieldKey ? 12 : 24" :lg="largeSize" v-show="showIDField">
      <text-field
        v-model="formData[idField]"
        :base="base"
        :name="idField"
        :labelText="idLabel"
        :isForm="true"
        :readonly="true"
        :disabled="true"
        :unhideID="formData[unhideIDField]"
        :unhideIDField="unhideIDField"
        >
      </text-field>
    </el-col>
    <el-col :xs="24" :md="12" :lg="largeSize" v-if="extraFieldKey">
      <text-field
        v-model="formData[extraFieldKey]"
        :name="extraFieldName"
        placeholderText=""
        readonly
        disabled
        >
      </text-field>
    </el-col>
    <el-col :xs="24" :md="12" :lg="largeSize">
      <time-field
        v-if="formData.created_at"
        v-model="formData.created_at"
        :base="base"
        name="createdAt"
        readonly
        disabled
        >
      </time-field>
    </el-col>
    <el-col :xs="24" :md="12" :lg="largeSize">
      <time-field
        v-if="formData.updated_at"
        v-model="formData.updated_at"
        :base="base"
        name="updatedAt"
        readonly
        disabled
        >
      </time-field>
    </el-col>
  </el-row>
</template>

<script>

import { getLabelText } from '@/utils/i18n'

export default {
  name: 'base-field',
  props: {
    base: {
      type: String,
      required: true
    },
    idField: {
      type: String,
      default: 'id'
    },
    showIDField: {
      type: Boolean,
      default: true
    },
    unhideIDField: {
      type: String,
      default: ''
    },
    extraFieldKey: {
      type: String,
      default: ''
    },
    extraFieldName: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    idLabel () {
      return this.getLabelText(this.base, 'id') || 'ID'
    },
    largeSize () {
      let numOfFields = 2 + (this.extraFieldKey ? 1 : 0) + (this.showIDField ? 1 : 0)
      return 24 / numOfFields
    }
  },
  methods: {
    getLabelText
  }
}
</script>
